import { useFormikContext } from "formik";
import { ComponentPropsWithoutRef } from "react";
import Spinner, { SpinnerSize } from "shared/components/common/Spinner";

type PillarFormLoadingSubmitButtonProps = ComponentPropsWithoutRef<"button"> & {
  label?: string;
  testid?: string;
  className?: string;
  isLoading?: boolean;
  errorMessageClassName?: string;
};

const PillarFormLoadingSubmitButton = ({
  label,
  testid,
  className,
  isLoading,
  errorMessageClassName,
  ...props
}: PillarFormLoadingSubmitButtonProps) => {
  const { handleSubmit, isSubmitting, status } = useFormikContext();

  const handleClick = async () => {
    handleSubmit();
  };

  return (
    <>
      <button
        data-testid={testid}
        type="button"
        className={`button-regular-general-filled w-10 ${className ?? ""}`}
        disabled={isSubmitting || isLoading}
        onClick={handleClick}
        {...props}
      >
        {isSubmitting || isLoading ? (
          <Spinner spinnerSize={SpinnerSize.Small} />
        ) : (
          <>
            {label && label}
            {props.children}
          </>
        )}
      </button>
      {status?.error && (
        <div
          className={`text-status-danger text-sm ${
            errorMessageClassName || ""
          }`}
          data-testid={`${testid}-error-message`}
        >
          {status.error}
        </div>
      )}
      {status?.success && (
        <div className="text-status-success text-sm">{status.success}</div>
      )}
    </>
  );
};

export default PillarFormLoadingSubmitButton;
